













import { Component, Prop, Vue, Watch } from 'vue-property-decorator'

@Component
export default class InputField extends Vue {
  private validationMessage = ''
  private classes: string[] = []

  @Prop({ type: String, default: null })
  private readonly value!: string | null

  @Prop({ type: Boolean, default: false })
  private readonly disabled!: boolean

  @Prop({ type: Array, default: () => [] })
  private readonly rules!: [(value: string) => boolean | string] | []

  // 非活性状態が解除された時validationをかけるため監視
  @Watch('disabled')
  private changeDisabled(newValue: boolean): void {
    if (newValue) {
      this.validationMessage = ''
      this.classes = []
      return
    } else {
      this.validation(this.value)
    }
  }

  private validation(value: string | null): void {
    if (!this.rules || this.disabled) return
    if (value == null) value = ''
    this.validationMessage = ''
    this.classes = []
    this.rules.forEach((rule) => {
      if (this.validationMessage) return
      if (typeof rule(value as string) === 'string' && !this.validationMessage) {
        this.validationMessage = rule(value as string) as string
        this.classes = ['input-field--valid']
      }
    })
  }

  private updateValue(event: Event): void {
    const inputValue = (event.target as HTMLInputElement).value
    this.validation(inputValue)
    this.$emit('input', inputValue)
  }
}
